import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { CategoriesAPI } from '../api/categories/categoriesapi';
import { CategoriesRequest } from '../api/categories/categoriesrequest';
import { CategoriesResponse } from '../api/categories/categoriesresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { CategoriesAPIProcessorImpl } from '../processor/categoriesapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';
import { SignupCategoriesRequest } from '../api/signupcategories/signupcategoriesrequest';
import { SignupCategoriesResponse } from '../api/signupcategories/signupcategoriesresponse';
import { SignupCategoriesAPI } from '../api/signupcategories/signupcategoriesapi';
import { SignupCategoriesAPIProcessorImpl } from '../processor/signupcategoriesapiprocessor';

export class CategoriesProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(CategoriesProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getCategories():APIProcessor<CategoriesRequest, CategoriesResponse>
    {
        this.logger.log("getCategories() invoked");
        return new CategoriesAPIProcessorImpl(this.getContext(), new CategoriesAPI(this.getHttpClient(), this.getContext()));
    }

    getSignUpCategories():APIProcessor<SignupCategoriesRequest, SignupCategoriesResponse>
    {
        this.logger.log("getCategories() invoked");
        return new SignupCategoriesAPIProcessorImpl(this.getContext(), new SignupCategoriesAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/categoriesprocessorfactory.tsx